<template>
  <div v-if="volunteer" class="volunteerstandardmatch">
    <div class="row content">
      <div class="col-lg-4 col-xl-3 mb-3 mb-lg-0 volunteer-area">
        <VolunteerCardStandard
          v-model="volunteer"
          :group="group"
          :show-actions="false"
        />
      </div>

      <div class="col-lg-8 col-xl-9 customer-area">
        <div class="row d-lg-none">
          <h4>{{ $t('customerSearch.customerMatchDetails') }}</h4>
        </div>
        <div class="row ml-lg-1 customer-summary">
          <div v-if="hasFriendship" class="col">
            <VolunteerMatchSummaryStandard
              :group="group"
              :volunteer="volunteer"
              :customer="customer"
              @close="onClose"
              @cancelpending="onCancelPending"
              @activate="onActivate"
              @terminate="onTerminate"
            />
          </div>
          <div v-else class="customer-not-found">
            <font-awesome-icon icon="exclamation-triangle" />{{ $t('customerSearch.matchVolunteerNoLongerExists') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue'
  import * as _ from 'lodash'
  import VolunteerCardStandard from './VolunteerCardStandard.vue'
  import VolunteerMatchSummaryStandard from './VolunteerMatchSummaryStandard.vue'
  import { FriendManagementDto, FriendCustomerStandardDto, FriendProfileDto, FriendshipStandardDto, FriendshipStandardCommandCriteria } from '@/types/index'

  export default Vue.extend({
    name: 'VolunteerStandardMatchCustomer',
    components: { VolunteerCardStandard, VolunteerMatchSummaryStandard },
    props: {
      group: {
        type: Object as () => FriendManagementDto,
        required: true
      },
      customer: {
        type: Object as () => FriendCustomerStandardDto,
        required: true
      },
      volunteer: {
        type: Object as () => FriendProfileDto,
        required: true
      }
    },
    data () {
      return {
        score: 0,
        isLoading: false,
        isSending: false
      }
    },
    computed: {
      hasFriendship (): boolean {
        return this.volunteer.friendInfo.standardProfile.friendships != null && this.volunteer.friendInfo.standardProfile.friendships.length > 0
      }
    },
    mounted () {
      window.scrollTo(0, 0)
    },
    methods: {
      onClose () {
        // go back to the matches of the volunteer
        this.$router.push(`/friend/volunteerpreview/${this.group.id}/${this.volunteer.id}`)
      },
      onCancelPending (friendship: FriendshipStandardDto) {
        var data: FriendshipStandardCommandCriteria = this.getStandardFriendshipCommandCriteria(friendship)
        var url = `${this.$store.state.apiBases.friendservice + this.$store.state.apiEndpoints.friendshipcancelstandard[0]}`
        this.$http.post(url, data).then(resp => {
          this.$emit('oncancelpending')
        })
      },
      onActivate (friendship: FriendshipStandardDto) {
        var self = this
        var data: FriendshipStandardCommandCriteria = this.getStandardFriendshipCommandCriteria(friendship)
        var url = `${this.$store.state.apiBases.friendservice + this.$store.state.apiEndpoints.friendshipactivatestandard[0]}`
        this.$http.post(url, data).then(resp => {
          this.$emit('onactivate')
        })
      },
      onTerminate (friendship: FriendshipStandardDto) {
        var data: FriendshipStandardCommandCriteria = this.getStandardFriendshipCommandCriteria(friendship)
        var url = `${this.$store.state.apiBases.friendservice + this.$store.state.apiEndpoints.friendshipterminatestandard[0]}`
        this.$http.post(url, data).then(resp => {
          this.$emit('onterminate')
        })
      },
      getStandardFriendshipCommandCriteria (friendship: FriendshipStandardDto) {
        return {
          groupId: this.group?.id,
          customerProfileStandardId: friendship.customerProfileStandardId,
          volunteerStandardProfileId: friendship.friendVolunteerProfileStandardId
        } as FriendshipStandardCommandCriteria
      }
    }
  })
</script>

<style lang="scss">
  @import "../../assets/scss/_variables.scss";

  .volunteerstandardmatch {
    .header {
      margin-top: 10px;
      .nav-header {
        border-bottom: 0;
      }
      h4 {
        padding-left: 10px;
      }
    }
    .content {

      .volunteer-area {
        padding-top: 30px;
        background-color: $brand-white;
        border-left: solid 5px $volunteer-color-strong;
      }

      .customer-area {
        h4 {
          padding-left: 10px;
        }
        .customer-summary {
          @media (min-width: $media-lg) {
            height: 100%;
          }
        }
        .customer-not-found {
          height: 100%;
          text-align: center;
          margin-top: 50px;
          font-weight: bold;
          .fa {
            color: $brand-red;
            margin-right: 5px;
          }
        }
      }
    }
  }
</style>
